//----------------------
// <auto-generated>
//     Generated using Aya Client Generator [Version 1.0.3]
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { SortDirectionEnum } from './enums/sort-direction-enum.enum';
import { API_BASE_URL } from './misc/api-base-url.token';
import { blobToText } from './misc/blob-to-text.function';
import { FileParameter } from './misc/file-parameter.model';
import { FileResponse } from './misc/file-response.model';
import { throwException } from './misc/throw-exception.function';
import { CandidateDocumentMetadataDto } from './models/candidate-document-metadata-dto.model';
import { CandidateMetadataRequest } from './models/candidate-metadata-request.model';
import { CandidateVaccineDto } from './models/candidate-vaccine-dto.model';
import { MetadataConfigurationDto } from './models/metadata-configuration-dto.model';
import { MetadataFieldDto } from './models/metadata-field-dto.model';
import { MetadataFieldFilterValuesDto } from './models/metadata-field-filter-values-dto.model';
import { MetadataValueDto } from './models/metadata-value-dto.model';
import { PagingTokenOfMissingMetadataDto } from './models/paging-token-of-missing-metadata-dto.model';
import { SaveMetadataRequestDto } from './models/save-metadata-request-dto.model';
import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

@Injectable({
    providedIn: 'root'
})
export class MetadataClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    requestMetadataFieldsAndValues(request: CandidateMetadataRequest): Observable<CandidateDocumentMetadataDto[]> {
        let url_ = this.baseUrl + "/AyaNova/compliance/metadata/request-values";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRequestMetadataFieldsAndValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRequestMetadataFieldsAndValues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CandidateDocumentMetadataDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CandidateDocumentMetadataDto[]>;
        }));
    }

    protected processRequestMetadataFieldsAndValues(response: HttpResponseBase): Observable<CandidateDocumentMetadataDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CandidateDocumentMetadataDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getMetadataFields(documentTypeId: number | undefined, candidateDocumentId: number | undefined, contractId: number | null | undefined): Observable<MetadataFieldDto[]> {
        let url_ = this.baseUrl + "/AyaNova/compliance/metadata/fields?";
        if (documentTypeId === null)
            throw new Error("The parameter 'documentTypeId' cannot be null.");
        else if (documentTypeId !== undefined)
            url_ += "documentTypeId=" + encodeURIComponent("" + documentTypeId) + "&";
        if (candidateDocumentId === null)
            throw new Error("The parameter 'candidateDocumentId' cannot be null.");
        else if (candidateDocumentId !== undefined)
            url_ += "candidateDocumentId=" + encodeURIComponent("" + candidateDocumentId) + "&";
        if (contractId !== undefined && contractId !== null)
            url_ += "contractId=" + encodeURIComponent("" + contractId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMetadataFields(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMetadataFields(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MetadataFieldDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MetadataFieldDto[]>;
        }));
    }

    protected processGetMetadataFields(response: HttpResponseBase): Observable<MetadataFieldDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MetadataFieldDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getNotUserDefinedMetadataFieldsByContract(contractId: number, documentTypeId: number | undefined, candidateDocumentId: number | undefined): Observable<CandidateDocumentMetadataDto[]> {
        let url_ = this.baseUrl + "/AyaNova/compliance/metadata/fields/{contractId}?";
        if (contractId === undefined || contractId === null)
            throw new Error("The parameter 'contractId' must be defined.");
        url_ = url_.replace("{contractId}", encodeURIComponent("" + contractId));
        if (documentTypeId === null)
            throw new Error("The parameter 'documentTypeId' cannot be null.");
        else if (documentTypeId !== undefined)
            url_ += "documentTypeId=" + encodeURIComponent("" + documentTypeId) + "&";
        if (candidateDocumentId === null)
            throw new Error("The parameter 'candidateDocumentId' cannot be null.");
        else if (candidateDocumentId !== undefined)
            url_ += "candidateDocumentId=" + encodeURIComponent("" + candidateDocumentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNotUserDefinedMetadataFieldsByContract(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNotUserDefinedMetadataFieldsByContract(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CandidateDocumentMetadataDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CandidateDocumentMetadataDto[]>;
        }));
    }

    protected processGetNotUserDefinedMetadataFieldsByContract(response: HttpResponseBase): Observable<CandidateDocumentMetadataDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CandidateDocumentMetadataDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getFilteredMetadataFields(filterValues: MetadataFieldFilterValuesDto): Observable<MetadataFieldDto[]> {
        let url_ = this.baseUrl + "/AyaNova/compliance/metadata/fields/filter";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filterValues);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFilteredMetadataFields(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFilteredMetadataFields(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MetadataFieldDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MetadataFieldDto[]>;
        }));
    }

    protected processGetFilteredMetadataFields(response: HttpResponseBase): Observable<MetadataFieldDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MetadataFieldDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getMissingMetadata(filter_CandidateName: string | null | undefined, filter_DocumentTypeName: string | null | undefined, filter_DocumentTypeCategories: string[] | null | undefined, filter_CandidateLob: string | null | undefined, pageSize: number | undefined, skip: number | undefined, sort_Field: string | null | undefined, sort_Type: SortDirectionEnum | undefined, paginated: boolean | undefined): Observable<PagingTokenOfMissingMetadataDto> {
        let url_ = this.baseUrl + "/AyaNova/compliance/metadata/missing?";
        if (filter_CandidateName !== undefined && filter_CandidateName !== null)
            url_ += "Filter.CandidateName=" + encodeURIComponent("" + filter_CandidateName) + "&";
        if (filter_DocumentTypeName !== undefined && filter_DocumentTypeName !== null)
            url_ += "Filter.DocumentTypeName=" + encodeURIComponent("" + filter_DocumentTypeName) + "&";
        if (filter_DocumentTypeCategories !== undefined && filter_DocumentTypeCategories !== null)
            filter_DocumentTypeCategories && filter_DocumentTypeCategories.forEach(item => { url_ += "Filter.DocumentTypeCategories=" + encodeURIComponent("" + item) + "&"; });
        if (filter_CandidateLob !== undefined && filter_CandidateLob !== null)
            url_ += "Filter.CandidateLob=" + encodeURIComponent("" + filter_CandidateLob) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "Skip=" + encodeURIComponent("" + skip) + "&";
        if (sort_Field !== undefined && sort_Field !== null)
            url_ += "Sort.Field=" + encodeURIComponent("" + sort_Field) + "&";
        if (sort_Type === null)
            throw new Error("The parameter 'sort_Type' cannot be null.");
        else if (sort_Type !== undefined)
            url_ += "Sort.Type=" + encodeURIComponent("" + sort_Type) + "&";
        if (paginated === null)
            throw new Error("The parameter 'paginated' cannot be null.");
        else if (paginated !== undefined)
            url_ += "Paginated=" + encodeURIComponent("" + paginated) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMissingMetadata(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMissingMetadata(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagingTokenOfMissingMetadataDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagingTokenOfMissingMetadataDto>;
        }));
    }

    protected processGetMissingMetadata(response: HttpResponseBase): Observable<PagingTokenOfMissingMetadataDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PagingTokenOfMissingMetadataDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    saveMetadata(metadataRequest: SaveMetadataRequestDto): Observable<void> {
        let url_ = this.baseUrl + "/AyaNova/compliance/metadata";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(metadataRequest);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveMetadata(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveMetadata(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSaveMetadata(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getCovidMetadata(candidateDocumentId: number, documentTypeId: number): Observable<CandidateVaccineDto> {
        let url_ = this.baseUrl + "/AyaNova/compliance/metadata/covid/{candidateDocumentId}/{documentTypeId}";
        if (candidateDocumentId === undefined || candidateDocumentId === null)
            throw new Error("The parameter 'candidateDocumentId' must be defined.");
        url_ = url_.replace("{candidateDocumentId}", encodeURIComponent("" + candidateDocumentId));
        if (documentTypeId === undefined || documentTypeId === null)
            throw new Error("The parameter 'documentTypeId' must be defined.");
        url_ = url_.replace("{documentTypeId}", encodeURIComponent("" + documentTypeId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCovidMetadata(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCovidMetadata(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CandidateVaccineDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CandidateVaccineDto>;
        }));
    }

    protected processGetCovidMetadata(response: HttpResponseBase): Observable<CandidateVaccineDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CandidateVaccineDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getMetadataConfiguration(documentTypeId: number): Observable<MetadataConfigurationDto> {
        let url_ = this.baseUrl + "/AyaNova/compliance/metadata/configuration/{documentTypeId}";
        if (documentTypeId === undefined || documentTypeId === null)
            throw new Error("The parameter 'documentTypeId' must be defined.");
        url_ = url_.replace("{documentTypeId}", encodeURIComponent("" + documentTypeId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMetadataConfiguration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMetadataConfiguration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MetadataConfigurationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MetadataConfigurationDto>;
        }));
    }

    protected processGetMetadataConfiguration(response: HttpResponseBase): Observable<MetadataConfigurationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MetadataConfigurationDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    verifyMetadataFields(candidateDocumentId: number, documentTypeId: number, values: MetadataValueDto[]): Observable<boolean> {
        let url_ = this.baseUrl + "/AyaNova/compliance/metadata/{documentTypeId}/verify-fields/{candidateDocumentId}";
        if (candidateDocumentId === undefined || candidateDocumentId === null)
            throw new Error("The parameter 'candidateDocumentId' must be defined.");
        url_ = url_.replace("{candidateDocumentId}", encodeURIComponent("" + candidateDocumentId));
        if (documentTypeId === undefined || documentTypeId === null)
            throw new Error("The parameter 'documentTypeId' must be defined.");
        url_ = url_.replace("{documentTypeId}", encodeURIComponent("" + documentTypeId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(values);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processVerifyMetadataFields(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processVerifyMetadataFields(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processVerifyMetadataFields(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}